import React from 'react';

import style from './style.module.scss';
import IndyLink from 'components/IndyLink';

export function Asterisk({hashAnchor}){
    return (<IndyLink adr={hashAnchor}><span className={style.container}>*</span></IndyLink>);
}